import React, { useEffect, useState } from 'react'
import "./Count.css"
import { BsEmojiSmile,BsJournalRichtext,BsHeadset } from "react-icons/bs";


function Counter({ start, end, duration }) {
    const [count, setCount] = useState(start);
  
    useEffect(() => {
      let startTime;
      let animationFrameId;
  
      const animateCounter = (timestamp) => {
        if (!startTime) startTime = timestamp;
  
        const elapsedTime = timestamp - startTime;
        const progress = Math.min(1, elapsedTime / (duration * 1000));
        const currentValue = Math.floor(start + (end - start) * progress);
  
        setCount(currentValue);
  
        if (progress < 1) {
          animationFrameId = requestAnimationFrame(animateCounter);
        }
      };
  
      animationFrameId = requestAnimationFrame(animateCounter);
  
      return () => {
        cancelAnimationFrame(animationFrameId);
      };
    }, [start, end, duration]);
  
    return <span className="purecounter">{count}</span>;
  }

export default function Count() {
  return (
    <section id="counts" className="counts">
      <div className="container" data-aos="fade-up">

        <div className="row gy-4 justify-content-center">

          <div className="col-lg-4 col-md-6 col-sm-10 col-10">
            <div className="count-box">
              <div className='count-review'>
              <BsEmojiSmile className='smile'/>
              </div>
              <div className='count-review1'>
                <Counter start={0} end={43} duration={1} />
                <p>Happy Clients</p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 col-sm-10 col-10">
            <div className="count-box">
            <div className='count-review'>
            <BsJournalRichtext className='reachtext'/>
              </div>
              
              <div className='count-review1'>
                <Counter start={10} end={87} duration={2} />
                <p>Projects</p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 col-sm-10 col-10">
            <div className="count-box">
              <div className='count-review'>
              <BsHeadset className='headset'/>

              </div>
              <div className='count-review1'>
                <Counter start={50} end={500} duration={3} />
                <p>Hours Of Support</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
